<script>
import DatePicker from 'vue-datepicker-next';

export default {
  name: 'DateTimeRangePicker',
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: 'Apply',
    },
    placeholder: {
      type: String,
      default: 'Select date and time range',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change'],
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-time-picker">
    <DatePicker
      range
      type="datetime"
      confirm
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      format="YYYY-MM-DD HH:mm"
      value-format="YYYY-MM-DD HH:mm:ss"
      @change="handleChange"
    />
  </div>
</template>

<style scoped>
.date-time-picker {
  min-width: 300px;
}

/* Ensure the datetime picker has enough space */
:deep(.mx-datepicker) {
  width: 100%;
}

:deep(.mx-input) {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
}

:deep(.mx-input:focus) {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}
</style>
